module.exports = __webpack_public_path__ + "img/flatuicolors.com.6448364e.png";